import React from 'react';
import Divider from '../Divider';

interface IHeadlineProps {
  h: number;
  className?: string;
  underline?: boolean;
  children: any;
}

const Headline = (props: IHeadlineProps) => {
  const { h, className, children, underline = true } = props;
  const Tag: any = `h${h}`;
  const cn = className && className.length ? className : '';
  return (
    <Tag className={`headline ${cn}`}>
      {children}
      <br />
      {underline && <Divider />}
    </Tag>
  );
}

export default Headline;